import type { DomainSchema, PdfCardDef } from '../types';
import { fmtDate, esc, metaJoin } from '../pdf-helpers';

export const ARTICLES = {
  priority: true,
  cardTitle: '{title}',
  fields: {
    articleId: { type: 'text', hidden: true },
    title: { type: 'text' },
    url: { type: 'text', label: 'URL' },
    summary: { type: 'textarea' },
    publishedAt: { type: 'date', label: 'Published' },
    lastModifiedAt: { type: 'date', hidden: true },
    visibility: { type: 'text' },
  },
  layout: [
    [{ field: 'visibility' }, { field: 'publishedAt' }],
    [{ field: 'url' }],
    [{ field: 'summary' }],
  ],
  editLayout: [
    [{ field: 'title' }],
    [{ field: 'visibility' }, { field: 'publishedAt' }],
    [{ field: 'url' }],
    [{ field: 'summary' }],
  ],
} satisfies DomainSchema;

export const ArticlesPdfCard: PdfCardDef = {
  styles: `
    .article-item { padding: 0.7rem 0; border-bottom: 1px solid var(--line); }
    .article-item:first-child { padding-top: 0; }
    .article-item:last-child { border-bottom: none; padding-bottom: 0; }
    .article-title { font-size: 12.5px; font-weight: 700; line-height: 1.35; }
    .article-meta  { font-size: 11px; color: var(--muted); margin-top: 3px; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([r['publishedAt'] ? fmtDate(r['publishedAt']) : null]);
        return `
          <div class="article-item">
            <div class="article-title">${esc(r['title'])}</div>
            ${meta ? `<div class="article-meta">${meta}</div>` : ''}
            ${r['summary'] ? `<div class="bp-note">${esc(r['summary'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
